import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IWorkingHoursService } from "services/WorkingHoursService";
import { WorkingHoursModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { toast } from "react-toastify";
import dayjs from "global/dayjs";

type StandardWorkingHoursState = {
  WorkingHours: Array<WorkingHoursModel> | null;
  IsLoading: boolean;
};

const initialState: StandardWorkingHoursState = {
  WorkingHours: null,
  IsLoading: false,
};

export const standardWorkingHoursSlice = createSlice({
  name: "StandardWorkingHours",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getWorkingHours.pending, (state) => {
        state.IsLoading = true;
      })
      .addCase(getWorkingHours.fulfilled, (state, action) => {
        state.WorkingHours = action.payload;
        state.IsLoading = false;
      })
      .addCase(getWorkingHours.rejected, (state) => {
        state.IsLoading = false;
      })
      .addCase(updateWorkingHours.fulfilled, () => {
        toast.success("Standard Working Hours Updated");
      });
  },
});

export const getWorkingHours = createAsyncThunk("StandardWorkingHours/GetWorkingHours", async () => {
  const workingHoursService = container.get<IWorkingHoursService>(SERVICE_TYPES.WorkingHoursService);
  return await workingHoursService.getStandardWorkingHours();
});

export const updateWorkingHours = createAsyncThunk(
  "StandardWorkingHours/UpdateWorkingHours",
  async (workingHours: WorkingHoursModel, thunkAPI) => {
    const workingHoursService = container.get<IWorkingHoursService>(SERVICE_TYPES.WorkingHoursService);
    workingHours.openTime = dayjs(workingHours.openTime, "HH:mm").format("HH:mm:ss");
    workingHours.closeTime = dayjs(workingHours.closeTime, "HH:mm").format("HH:mm:ss");
    await workingHoursService.updateStandardWorkingHours(workingHours);
    thunkAPI.dispatch(getWorkingHours());
  }
);

export const selectIsLoading = (state: RootState) => {
  return state.standardWorkingHours.IsLoading;
};
export const selectWorkingHours = (state: RootState) => {
  return state.standardWorkingHours.WorkingHours;
};

export default standardWorkingHoursSlice.reducer;
